import { FaLayerGroup } from 'react-icons/fa';
import { IoFilterSharp, IoSearchSharp } from 'react-icons/io5';

const BacklogHeader = () => {
  return (
    <div className="px-4">
      <div className="mt-0 flex w-full items-center justify-between">
        <div className="mx-1.5 flex items-end">
          <button className="inline-flex items-center justify-center gap-1.5 border border-zinc-700 px-3 py-1  text-base font-semibold">
            <IoFilterSharp size={18} />
            Filter
          </button>
          <button className="inline-flex items-center justify-center gap-1.5 border border-zinc-700 px-3 py-1 text-base font-semibold">
            <FaLayerGroup size={18} />
            Group
          </button>
          <button className="inline-flex items-center  justify-center border border-zinc-700 px-2 py-1 font-semibold">
            <IoSearchSharp size={24} className="font-bold text-white" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default BacklogHeader;
